<template>
  <div class="table table-bg treeview search">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>재고 리스트</h2>
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40" :disabled="downloading">
            <span v-if="!downloading"><img src="/static/img/ico_excel@2x.png" alt=""></span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
      </div>
    </div>
    <div v-if="searchCondition && searchCondition.length > 0" class="table-desc">
      <table>
        <tr class="header">
          <th>트레이 이름</th>
          <th>상품 이름</th>
          <th>입고 개수</th>
          <th>입고 금액</th>
          <th>폐기 개수</th>
          <th>폐기 금액</th>
        </tr>

        <tbody v-if="loading === false && total > 0">
          <tr v-for="item in list" :key="item.trayID">
            <td>
              <div>{{ item.trayName }}</div>
            </td>
            <td>
              <div>{{ item.productName }}</div>
            </td>
            <td>
              <div>{{ Number(item.stockCount).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ Number(item.stockTotal).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ Number(item.discardCount).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ Number(item.discardTotal).toLocaleString() }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="10">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="table-desc">
      <table>
        <tr class="header">
          <th>트레이 이름</th>
          <th>상품 이름</th>
          <th>최대 개수</th>
          <th>현재 개수</th>
          <th style="color:red;">필요 개수</th>
          <th>폐기 대상</th>
          <th>최근 입고 일자</th>
          <th>수정</th>
          <th>폐기 개수</th>
          <th>폐기 금액</th>
        </tr>

        <tbody v-if="loading === false && total > 0">
          <tr v-for="item in list" :key="item.trayID">
            <td>
              <div>{{ item.trayName }}</div>
            </td>
            <td>
              <div v-if="item.productID">
                {{ item.productName }}
              </div>
              <div v-else>
                <select v-model="item.newProduct" class="select middle">
                  <option v-for="product in productList" :key="product" :value="product">
                    {{ product.productName }}
                  </option>
                </select>
              </div>
            </td>
            <td>
              <div v-if="item.productID">
                {{ Number(item.capacity).toLocaleString() }}
              </div>
              <div v-else>
                <input
                  v-model="item.capacity"
                  type="text"
                  class="input small"
                  placeholder="숫자"
                />
              </div>
            </td>
            <td>
              <div>{{ Number(item.currentCount).toLocaleString() }}</div>
            </td>
            <td style="color:red;">
              <div>{{ Number(item.needCount).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ Number(item.expireCount).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ item.stockedDate }}</div>
            </td>
            <td>
              <div class="row">
                <div class="col">
                  <input
                    v-model="item.count"
                    type="text"
                    class="input small"
                    placeholder="숫자"
                  />
                </div>
                <div class="col">
                  <button v-if="!item.productID" class="btn btn-140" @click="addProduct(item, 1)">
                    입고
                  </button>
                  <button v-else class="btn btn-140" @click="addProduct(item, 2)">
                    입고
                  </button>
                </div>
                <div class="col">
                  <button class="btn btn-140" @click="discardProduct(item)">
                    폐기
                  </button>
                </div>
                <!-- TODO
                <div class="col">
                  <button type="button" class="btn btn-140 disabled" disabled @click="correctProduct(item)">
                    정정
                  </button>
                </div>
                -->
              </div>
            </td>
            <td>
              <div>{{ Number(item.discardCount).toLocaleString() }}</div>
            </td>
            <td>
              <div>{{ Number(item.discardTotal).toLocaleString() }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="10">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel
import ButtonLoading from '@/components/include/ButtonLoading';
import Device from '../device/Device';

export default {
  components: {
    Device,
    ButtonLoading,
  },
  props: [
    'deviceID',
    'selectEvent',
    'searchCondition', 'searchEvent',
  ],
  data: () => ({
    list: [],
    total: 0,
    loading: true,
    downloading: false,
    device: null,
    productList: [],
  }),
  /*
  created() {
    this.total = 0;
    this.getList(false);
  },
  */
  watch: {
    selectEvent() {
      this.total = 0;
      this.getList(false);
    },
    searchEvent() {
      this.total = 0;
      this.getList(false);
    },
  },
  methods: {
    refreshList() {
      this.total = 0;
      this.getList(false);
    },
    async getList(forDownload) {
      const list = [];
      if (!this.deviceID) {
        return list;
      }

      this.loading = true;
      if (!forDownload) {
        this.list = [];
      }

      try {
        let listURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${this.deviceID}/tray/product/stock`;
        if (this.searchCondition) {
          listURL += `?${this.searchCondition}`;
        }
        const resList = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (resList.status !== 200) {
          if (resList.status === 204) {
            this.total = 0;
            this.loading = false;
            return list;
          }

          throw new Error(`response status is "${resList.status}"`);
        }
        if (resList.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${resList.data.resultCode}"`);
        }

        this.device = resList.data.device;

        await this.getCompanyData(this.device);
        // await this.getDivisionData(this.device);
        // await this.getUserData(this.device);
        await this.getProductList(this.device);

        this.device.manufactureDate = this.$moment(this.device.manufactureAt).format('YYYY.MM.DD');
        // this.device.manufactureTime = this.$moment(this.device.manufactureAt).format('hh:mm A');
        this.device.manufactureTime = this.$moment(this.device.manufactureAt).format('HH:mm:ss');
        this.device.setupDate = this.$moment(this.device.setupAt).format('YYYY.MM.DD');
        // this.device.setupTime = this.$moment(this.device.setupAt).format('hh:mm A');
        this.device.setupTime = this.$moment(this.device.setupAt).format('HH:mm:ss');

        if (resList.data.device.trays) {
          this.total = resList.data.device.trays.length;
          let num = this.total;

          for (let i = 0; i < resList.data.device.trays.length; i++) {
            const t = resList.data.device.trays[i];
            t.num = num;
            if (t.products && t.products.length > 0) {
              const p = t.products[0];
              t.productID = p.productID;
              t.productName = p.productName;
              t.capacity = p.capacity;
              t.currentCount = p.currentCount;
              t.needCount = p.capacity - p.currentCount;
              t.stockedDate = p.stockedAt ? this.$moment(p.stockedAt).format('YYYY.MM.DD') : '-';
              // t.stockedTime = p.stockedAt ? this.$moment(p.stockedAt).format('hh:mm A') : '-';
              t.stockedTime = p.stockedAt ? this.$moment(p.stockedAt).format('HH:mm:ss') : '-';
              t.expireCount = p.expireCount;
              t.discardCount = p.discardCount;
              t.discardTotal = p.discardTotal;
              t.stockCount = p.stockCount;
              t.stockTotal = p.stockTotal;
            } else {
              t.capacity = 0;
              t.currentCount = 0;
              t.needCount = 0;
              t.expireCount = 0;
            }
            t.newProduct = null;
            t.count = 0;
            list.push(t);
            num--;
          }

          if (!forDownload) {
            this.list = list;
          }
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.total = 0;
        if (!forDownload) {
          this.list = [];
        }

        console.error(e);
      }
      return list;
    },
    async getCompanyData(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${value.companyID}?withDivisions=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          value.registrationNo = response.data.company.registrationNo;
          value.companyName = response.data.company.companyName;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getDivisionData(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/division/${value.divisionID}?withUsers=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          value.divisionName = response.data.division.divisionName;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUserData(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${value.operatorUID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          value.operatorName = response.data.user.name;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getProductList(value) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CPRODUCT_ADDRESS')}/api/v1/cproduct/product/list?page=1&limit=500&companyID=${value.companyID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          this.productList = response.data.products;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async addProduct(item, type) {
      if (item.count > 0) {
        try {
          const tpds = [
            {
              count: parseInt(item.count, 10),
            },
          ];

          let productName = item.productName;
          if (type === 1) {
            if (!item.newProduct) {
              alert('상품을 선택해 주세요.');
              return;
            }
            if (item.capacity === 0) {
              alert('최대 개수를 입력해 주세요.');
              return;
            }
            productName = item.newProduct.productName;
          }

          if (confirm(`${productName}(${item.count})를 입고하시겠습니까?`)) {
            let param = null;
            if (type === 1) {
              param = {
                deviceID: item.deviceID,
                trayID: item.trayID,
                productID: item.newProduct.productID,
                capacity: parseInt(item.capacity, 10),
                trayProductDetails: tpds,
              };
            } else {
              param = {
                deviceID: item.deviceID,
                trayID: item.trayID,
                productID: item.productID,
                trayProductDetails: tpds,
              };
            }

            const url = `${Configuration.value(
              'CPRODUCT_ADDRESS',
            )}/api/v1/cproduct/tray/${item.trayID}/product`;
            const resList = await this.$http.post(url,
              param,
              {
                headers: {
                  Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
                },
              });
            if (resList.status !== 200) {
              if (resList.status === 204) {
                this.getList(false);
                return;
              }

              throw new Error(`response status is "${resList.status}"`);
            }
            if (resList.data.resultCode !== '0000') {
              throw new Error(`resultcode is "${resList.data.resultCode}"`);
            }

            this.getList(false);
          }
        } catch (e) {
          alert('처리하지 못했습니다.\n잠시후 다시 시도해주세요.');
          console.error(e);
        }
      }
    },
    async discardProduct(item) {
      if (!item.productID) return;
      if (item.count > 0) {
        try {
          const tpds = [
            {
              count: parseInt(item.count, 10),
            },
          ];

          if (confirm(`${item.productName}(${item.count})를 폐기하시겠습니까?`)) {
            const url = `${Configuration.value(
              'CPRODUCT_ADDRESS',
            )}/api/v1/cproduct/tray/${item.trayID}/product/discard`;
            const resList = await this.$http.put(url,
              {
                deviceID: item.deviceID,
                trayID: item.trayID,
                productID: item.productID,
                trayProductDetails: tpds,
              },
              {
                headers: {
                  Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
                },
              });
            if (resList.status !== 200) {
              if (resList.status === 204) {
                this.getList(false);
                return;
              }

              throw new Error(`response status is "${resList.status}"`);
            }
            if (resList.data.resultCode !== '0000') {
              throw new Error(`resultcode is "${resList.data.resultCode}"`);
            }

            this.getList(false);
          }
        } catch (e) {
          alert('처리하지 못했습니다.\n잠시후 다시 시도해주세요.');
          console.error(e);
        }
      }
    },
    async resetProduct(item) {
      if (!item.productID) return;
      try {
        if (confirm(`${item.productName}를 초기화 하시겠습니까?`)) {
          const url = `${Configuration.value(
            'CPRODUCT_ADDRESS',
          )}/api/v1/cproduct/tray/${item.trayID}/product/reset`;
          const resList = await this.$http.put(url,
            {
              deviceID: item.deviceID,
              trayID: item.trayID,
              productID: item.productID,
            },
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              },
            });
          if (resList.status !== 200) {
            if (resList.status === 204) {
              this.getList(false);
              return;
            }

            throw new Error(`response status is "${resList.status}"`);
          }
          if (resList.data.resultCode !== '0000') {
            throw new Error(`resultcode is "${resList.data.resultCode}"`);
          }

          this.getList(false);
        }
      } catch (e) {
        alert('처리하지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async correctProduct(item) {
      if (!item.productID) return;
      try {
        const tpds = [
          {
            count: 1, // WARNING 무조건 1
          },
        ];

        if (confirm(`${item.productName}(${item.count})를 정정하시겠습니까?`)) {
          let param = null;
          param = {
            deviceID: item.deviceID,
            trayID: item.trayID,
            productID: item.productID,
            correctCount: parseInt(item.count, 10),
            trayProductDetails: tpds,
          };

          const url = `${Configuration.value(
            'CPRODUCT_ADDRESS',
          )}/api/v1/cproduct/tray/${item.trayID}/product/correct`;
          const resList = await this.$http.put(url,
            param,
            {
              headers: {
                Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              },
            });
          if (resList.status !== 200) {
            if (resList.status === 204) {
              this.getList(false);
              return;
            }

            throw new Error(`response status is "${resList.status}"`);
          }
          if (resList.data.resultCode !== '0000') {
            throw new Error(`resultcode is "${resList.data.resultCode}"`);
          }

          this.getList(false);
        }
      } catch (e) {
        alert('처리하지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async downloadExcel() {
      try {
        this.downloading = true;
        const sales = [];
        const list = await this.getList(true);
        for (let j = 0; j < list.length; j++) {
          const it = list[j];
          const c = {
            사업자번호: this.device.registrationNo,
            회사이름: this.device.companyName,
            '냉장고 ID': this.device.deviceID,
            '냉장고 이름': this.device.deviceName,
            '트레이 ID': it.trayID,
            '트레이 이름': it.trayName,
            '상품 ID': it.productID,
            '상품 이름': it.productName,
            최대개수: it.capacity,
            현재개수: it.currentCount,
            필요개수: it.needCount,
            최근입고날짜: `${it.stockedDate} ${it.stockedTime}`,
            페기대상: it.expireCount,
            폐기개수: it.discardCount,
            폐기금액: it.discardTotal,
            입고개수: it.stockCount,
            입고금액: it.stockTotal,
          };
          sales.push(c);
        }

        if (sales.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          this.downloading = false;
          return;
        }

        js2excel.json2excel({
          data: sales,
          name: 'cella-stock',
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }

      this.downloading = false;
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/stock/StockList.vue